module.exports = __webpack_public_path__ + "img/icon-result-5.4d761e99.svg";